var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertifiedBadge = function SvgCertifiedBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 20,
    x: 1,
    y: 1,
    fill: "#fff",
    rx: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 20,
    x: 1,
    y: 1,
    stroke: "#fff",
    strokeWidth: 2,
    rx: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 20,
    x: 1,
    y: 1,
    stroke: "url(#certified-badge_svg__a)",
    strokeOpacity: 0.34,
    strokeWidth: 2,
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.539 5a.2.2 0 0 1 .197.167l.064.378c.458 1.715 1.589 2.182 2.2 2.182V11c0 2.743-3.667 5.143-5.5 6-1.833-.857-5.5-3.257-5.5-6V7.727c.611 0 1.742-.467 2.2-2.182l.064-.378A.2.2 0 0 1 12.46 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "m15.115 12.5 3.3-3.5M15.037 12.5l-1.79-1.937"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.653 6.61v1.053h4.19V6.61h1.181v3.943H30.34v.891h3.835v.967h-8.852v-.967h3.814v-.891h-2.664V6.61zm0 2.987h4.19v-1.01h-4.19zm5.522 5.199v.967h-6.757v-2.729h1.192v1.762zm9.643-8.54v7.015h-1.203V6.256zm.269 8.54v.967h-6.693v-3.201h1.203v2.234zM37.522 6.89c1.472 0 2.61 1.02 2.61 2.427 0 1.44-1.138 2.439-2.61 2.439-1.482 0-2.621-1-2.621-2.439 0-1.407 1.139-2.427 2.621-2.427m0 1.042c-.827 0-1.46.547-1.45 1.385-.01.86.623 1.397 1.45 1.397.806 0 1.44-.537 1.44-1.397 0-.838-.634-1.385-1.44-1.385m14.703-1.676v7.015h-1.203V6.256zm.268 8.54v.967h-6.692v-3.201h1.203v2.234zM46.93 6.89c1.472 0 2.61 1.02 2.61 2.427 0 1.44-1.138 2.439-2.61 2.439-1.483 0-2.621-1-2.621-2.439 0-1.407 1.139-2.427 2.62-2.427m0 1.042c-.827 0-1.461.547-1.45 1.385-.011.86.623 1.397 1.45 1.397.806 0 1.44-.537 1.44-1.397 0-.838-.634-1.385-1.44-1.385m15.465 2.836v.966h-8.851v-.966zm-4.436 1.61c2.095 0 3.351.656 3.362 1.784-.01 1.139-1.267 1.783-3.362 1.783-2.116 0-3.384-.644-3.384-1.783 0-1.128 1.268-1.783 3.384-1.783m0 .935c-1.418 0-2.18.29-2.17.85-.01.558.752.848 2.17.848 1.386 0 2.159-.29 2.17-.849-.011-.559-.784-.849-2.17-.849m3.641-6.606v.978h-2.803c.177.805 1.343 1.53 3.18 1.708l-.42.945c-1.761-.188-3.072-.881-3.598-1.87-.527.984-1.816 1.682-3.577 1.87l-.409-.945c1.8-.178 2.97-.903 3.159-1.708h-2.783v-.978zm6.794-.043c1.418 0 2.427.784 2.438 1.955-.01.962-.736 1.687-1.815 1.89v.785a28 28 0 0 0 2.374-.226l.096.87c-2.02.366-4.275.398-5.919.398l-.128-.956c.698.005 1.514 0 2.374-.032v-.838c-1.112-.183-1.859-.913-1.848-1.89-.01-1.172.999-1.956 2.428-1.956m0 .913c-.774 0-1.322.387-1.311 1.042-.01.634.537 1.031 1.31 1.042.774-.01 1.3-.408 1.311-1.042-.01-.655-.537-1.042-1.31-1.042m4.758-1.321v3.137h1.31v.988h-1.31v3.287H71.96V6.256zm.344 8.53v.966H66.77v-2.74h1.193v1.773zm10.245-.946v.988h-8.873v-.988h2.352v-1.6h-1.3V9.07h5.587V7.878h-5.608V6.91h6.79v3.115h-5.576v1.247h5.8v.966h-1.417v1.6zm-5.36 0h1.944v-1.6h-1.945z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "certified-badge_svg__a",
    x1: 0,
    x2: 95,
    y1: 11,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopColor: "#ECCA20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#195EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3E9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF13C4"
  })))));
};
export default SvgCertifiedBadge;